Vue.component('assessment-form', {
    props: ['assessment'],
    data() {
        return {
            saving: false,
            countries : [],
            errors : [],
        }
    },
    computed: {
        canSave() {
            if (this.saving) {
                return false;
            }
            if (!this.assessment.assessment_commodities.length) {
                return false;
            }
            if (!this.assessment.name) {
                return false;
            }

            return true;
        }
    },
    methods: {
        loadCountries() {
            axios.get('/countries')
                 .then(response => {
                    this.countries = response.data;
                 });
        },
        checkRows() {
            this.errors = [];
            this.assessment.assessment_commodities.forEach((pivot, row) => {
                var passes = Boolean(pivot.amount) && Boolean(pivot.country_of_origin);
                if (passes) {
                    return;
                }

                this.errors[row] = {
                    'amount' : !Boolean(pivot.amount),
                    'country_of_origin' : !Boolean(pivot.country_of_origin),
                };
            });

            return !this.errors.length;
        },
        save() {
            if (!this.canSave) {
                return;
            }
            if (!this.checkRows()) {
                return;
            }

            this.saving = true;

            var endpoint = '/assessments';
            var method = 'post';
            if (this.assessment.id) {
                endpoint += '/'+ this.assessment.id;
                method = 'patch';
            }

            axios[method](endpoint, this.assessment)
                .then(response => {
                    if (!this.assessment.id) {
                        this.eventHub.$emit('assessmentCreated', response.data);
                    }

                    setTimeout(() => {
                        this.eventHub.$emit('calculate');
                    }, 1000);
                });
        },
        countriesFor(commodity)
        {
            var countryIds = [];
            commodity.commodity_processes.forEach(commodityProcess => {
               countryIds.push(commodityProcess.country_id);
            });

            return this.countries.filter(country => {
                return countryIds.includes(country.id);
            });
        },
        deleteCommodity(row, commodity) {
            this.$swal({
              title: 'Delete commodity?',
              text: 'Are you sure you want to delete '+ commodity.name +'?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes, delete it!',
            }).then((result) => {
                if (result.value) {
                    this.assessment.assessment_commodities.splice(row, 1);
                 }
            });
        },
        hasError(row, input) {
            if (this.errors.length == 0) {
                return false;
            }

            if (!this.errors[row]) {
                return false;
            }

            return (this.errors[row][input]);
        }
    },
    mounted() {
        this.loadCountries();
    }
});
